import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-action-confirm',
  templateUrl: './confirm-action.component.html',
  styleUrls: ['./confirm-action.component.scss'],
})
export class ActionConfirmComponent {
  @Input() titulo: string = 'Confirmación';
  @Input() mensaje: string = '¿Estás seguro?';
  @Input() onConfirm?: () => void;  // Función que se ejecuta al confirmar
  @Input() onClose?: () => void;    // Función que se ejecuta al cerrar

  ejecutarAccion() {
    if (this.onConfirm) {
      this.onConfirm();
    }
  }

  cerrarComponente() {
    if (this.onClose) {
      this.onClose();
    }
  }
}
